import _objectSpread from "D:/svnworkspace/GZEB/webWorks/e-boat-web/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { createVNode as _createVNode2, createTextVNode as _createTextVNode2, resolveComponent as _resolveComponent2 } from "vue";
import "core-js/modules/es.array.map.js";
import "core-js/modules/esnext.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
var _hoisted_1 = {
  class: "app-page dictionary"
};
var _hoisted_2 = {
  class: "container"
};
var _hoisted_3 = {
  class: "left"
};
var _hoisted_4 = {
  class: "search"
};
var _hoisted_5 = {
  class: "left-page"
};
var _hoisted_6 = {
  class: "right"
};
var _hoisted_7 = {
  key: 0,
  class: "data-empty"
};
import { Search, Delete, Edit, Plus } from '@element-plus/icons-vue';
import DictionaryItem from './DictionaryItem.vue';
import { queryPage } from '@/api/system/dictionary';
import { remove } from '@/api/system/dictionary-data';
import { isOnlyOne } from '@/utils/common';
import { deleteBox, toast } from '@/utils/message';
import { COMMON_ENABEL_STATUS } from '@/constant/system/code';
import { renderDictAddForm } from './dictAdd';
import { renderAddForm } from './dataAdd';
import { renderEditForm } from './dataEdit';
import { renderTable } from './table';

import { ref, reactive, onMounted, h } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'Dictionary',
  setup: function setup(__props) {
    var tableRef = ref();
    var currentItem = ref();
    var dataEditRef = ref();
    var dataAddRef = ref();
    var dictAddRef = ref();
    var table;
    var dataEdit;
    var dataAdd;
    var dictAdd;
    var searchData = reactive({});
    var listPage = reactive({
      pageNumber: 1,
      pageSize: 15,
      total: 0
    });
    var dictItems = ref();
    queryPage({
      pageNumber: listPage.pageNumber,
      pageSize: listPage.pageSize
    }).then(function (res) {
      dictItems.value = res.data.content;
    });
    onMounted(function () {
      table = renderTable(tableRef.value, {
        editFn: rowEdit,
        deleteFn: rowDetele
      }, tableActionHeader);
      dataAdd = renderAddForm(dataAddRef.value);
      dataAdd.onSaveSuccess = function () {
        var _currentItem$value;
        table.load({
          dictionaryId: (_currentItem$value = currentItem.value) === null || _currentItem$value === void 0 ? void 0 : _currentItem$value.id
        });
      };
      dataEdit = renderEditForm(dataEditRef.value);
      dataEdit.onSaveSuccess = function () {
        var _currentItem$value2;
        table.load({
          dictionaryId: (_currentItem$value2 = currentItem.value) === null || _currentItem$value2 === void 0 ? void 0 : _currentItem$value2.id
        });
      };
      dictAdd = renderDictAddForm(dictAddRef.value);
      dictAdd.onSaveSuccess = function () {
        loadDictList();
      };
    });
    // 新建字典数据
    function tableAdd() {
      dataAdd.open().then(function () {
        var _currentItem$value3;
        dataAdd.setSaveParams({
          dictionaryId: (_currentItem$value3 = currentItem.value) === null || _currentItem$value3 === void 0 ? void 0 : _currentItem$value3.id
        });
      });
    }
    // 更新字典数据
    function tableEdit() {
      var rows = table.getSelectRows();
      if (isOnlyOne(rows)) {
        dataEdit.open(rows[0].id);
      }
    }
    // 删除字典数据
    function tableDelete() {
      var rows = table.getSelectRows();
      deleteBox().then(function () {
        remove(rows.map(function (item) {
          return item.id;
        })).then(function () {
          var _currentItem$value4;
          toast.success('删除成功');
          table.load({
            dictionaryId: (_currentItem$value4 = currentItem.value) === null || _currentItem$value4 === void 0 ? void 0 : _currentItem$value4.id
          });
        });
      });
    }
    // 行编辑
    function rowEdit(row) {
      dataEdit.open(row.id);
    }
    // 行删除
    function rowDetele(row) {
      deleteBox().then(function () {
        remove([row.id]).then(function () {
          var _currentItem$value5;
          toast.success('删除成功');
          table.load({
            dictionaryId: (_currentItem$value5 = currentItem.value) === null || _currentItem$value5 === void 0 ? void 0 : _currentItem$value5.id
          });
        });
      });
    }
    // 左侧选中
    function select(item) {
      currentItem.value = item;
      table.load({
        dictionaryId: item.id
      });
    }
    // 左侧列表删除
    function resetSearch() {
      listPage.pageNumber = 1;
      loadDictList();
    }
    // 筛选
    function command(e) {
      searchData.status = e;
      listPage.pageNumber = 1;
      loadDictList();
    }
    // 字典添加
    function itemAdd() {
      dictAdd.open();
    }
    // 自定义表格头部
    function tableActionHeader() {
      var _currentItem$value6;
      return h(_createVNode2("div", {
        "style": {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          height: '50px'
        }
      }, [_createVNode2("div", {
        "style": {
          fontWeight: 600
        }
      }, [(_currentItem$value6 = currentItem.value) === null || _currentItem$value6 === void 0 ? void 0 : _currentItem$value6.dictionaryName]), _createVNode2("div", null, [_createVNode2(_resolveComponent2("el-button"), {
        "onClick": tableAdd,
        "type": "primary",
        "size": "small",
        "icon": Plus
      }, {
        default: function _default() {
          return [_createTextVNode2("\u65B0\u589E")];
        }
      }), _createVNode2(_resolveComponent2("el-button"), {
        "onClick": tableEdit,
        "type": "primary",
        "size": "small",
        "icon": Edit
      }, {
        default: function _default() {
          return [_createTextVNode2("\u7F16\u8F91")];
        }
      }), _createVNode2(_resolveComponent2("el-button"), {
        "onClick": tableDelete,
        "type": "primary",
        "size": "small",
        "icon": Delete
      }, {
        default: function _default() {
          return [_createTextVNode2("\u5220\u9664")];
        }
      })])]));
    }
    // 加载左侧列表
    function loadDictList() {
      queryPage(_objectSpread({
        pageNumber: listPage.pageNumber,
        pageSize: listPage.pageSize
      }, searchData)).then(function (res) {
        dictItems.value = res.data.content;
      });
    }
    return function (_ctx, _cache) {
      var _component_el_input = _resolveComponent("el-input");
      var _component_el_icon = _resolveComponent("el-icon");
      var _component_el_tooltip = _resolveComponent("el-tooltip");
      var _component_Filter = _resolveComponent("Filter");
      var _component_el_dropdown_item = _resolveComponent("el-dropdown-item");
      var _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");
      var _component_el_dropdown = _resolveComponent("el-dropdown");
      var _component_el_scrollbar = _resolveComponent("el-scrollbar");
      var _component_el_pagination = _resolveComponent("el-pagination");
      var _component_el_empty = _resolveComponent("el-empty");
      var _component_XFlexCtx = _resolveComponent("XFlexCtx");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_XFlexCtx, {
        flex: 1
      }, {
        default: _withCtx(function () {
          var _unref2, _unref3;
          return [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(_component_el_input, {
            modelValue: _unref(searchData).dictCodeOrName,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
              return _unref(searchData).dictCodeOrName = $event;
            }),
            onBlur: resetSearch,
            onKeydown: _withKeys(resetSearch, ["enter"]),
            style: {
              "width": "200px"
            },
            placeholder: "请输入字典名称或编码",
            clearable: "",
            "prefix-icon": _unref(Search)
          }, null, 8, ["modelValue", "prefix-icon"]), _createVNode(_component_el_tooltip, {
            content: "新增",
            placement: "top",
            effect: "light"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_icon, {
                onClick: itemAdd,
                style: {
                  "cursor": "pointer"
                }
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_unref(Plus))];
                }),
                _: 1
              })];
            }),
            _: 1
          }), _createVNode(_component_el_dropdown, {
            trigger: "click",
            onCommand: command
          }, {
            dropdown: _withCtx(function () {
              return [_createVNode(_component_el_dropdown_menu, null, {
                default: _withCtx(function () {
                  return [_createVNode(_component_el_dropdown_item, {
                    command: _unref(COMMON_ENABEL_STATUS).ENABLED.CODE
                  }, {
                    default: _withCtx(function () {
                      return _cache[1] || (_cache[1] = [_createTextVNode("启用")]);
                    }),
                    _: 1
                  }, 8, ["command"]), _createVNode(_component_el_dropdown_item, {
                    command: _unref(COMMON_ENABEL_STATUS).DISABLED.CODE
                  }, {
                    default: _withCtx(function () {
                      return _cache[2] || (_cache[2] = [_createTextVNode("禁用")]);
                    }),
                    _: 1
                  }, 8, ["command"]), _createVNode(_component_el_dropdown_item, {
                    command: ''
                  }, {
                    default: _withCtx(function () {
                      return _cache[3] || (_cache[3] = [_createTextVNode("全部")]);
                    }),
                    _: 1
                  })];
                }),
                _: 1
              })];
            }),
            default: _withCtx(function () {
              return [_createVNode(_component_el_icon, {
                style: {
                  "cursor": "pointer"
                }
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_Filter)];
                }),
                _: 1
              })];
            }),
            _: 1
          })]), _createVNode(_component_el_scrollbar, {
            style: {
              "height": "100%"
            }
          }, {
            default: _withCtx(function () {
              return [_createVNode(DictionaryItem, {
                items: _unref(dictItems) || [],
                onSelect: select,
                onUpdate: loadDictList,
                onDelete: resetSearch
              }, null, 8, ["items"])];
            }),
            _: 1
          }), _createElementVNode("div", _hoisted_5, [_createVNode(_component_el_pagination, {
            layout: "prev, pager, next",
            total: _unref(listPage).total,
            "page-size": _unref(listPage).pageSize
          }, null, 8, ["total", "page-size"])])]), _createElementVNode("div", _hoisted_6, [_withDirectives(_createElementVNode("div", {
            style: {
              "height": "100%"
            },
            ref_key: "tableRef",
            ref: tableRef
          }, null, 512), [[_vShow, (_unref2 = _unref(dictItems)) === null || _unref2 === void 0 ? void 0 : _unref2.length]]), !((_unref3 = _unref(dictItems)) !== null && _unref3 !== void 0 && _unref3.length) ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createVNode(_component_el_empty, {
            description: "暂无数据"
          })])) : _createCommentVNode("", true)])])];
        }),
        _: 1
      }), _createElementVNode("div", {
        ref_key: "dataAddRef",
        ref: dataAddRef
      }, null, 512), _createElementVNode("div", {
        ref_key: "dataEditRef",
        ref: dataEditRef
      }, null, 512), _createElementVNode("div", {
        ref_key: "dictAddRef",
        ref: dictAddRef
      }, null, 512)]);
    };
  }
});